// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__1z6oH","white":"styles_white__3E6tq"};